import { Injectable } from '@angular/core';

declare var gtag: any;

/*
  Generated class for the AnalyticsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AnalyticsProvider {

  emitEvent(event_category: string,
    eventAction: string,
    event_label: string = null,
    event_value: number = null) {
    gtag('event', eventAction, { event_category, event_label, eventAction, event_value });
  }

  enableTracking() {
    window['ga-disable-UA-118963994-2'] = false;
    this.emitEvent("general", "analytics_enabled");
    console.info("Analytics enabled");
  }

}



// WEBPACK FOOTER //
// ./src/providers/analytics/analytics.ts